
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetobanglorecab() {



    const cardData =
    {
        keyword: 'Pune to Bangalore Cab',
        heading: 'Meghana Cab : Pune to Bangalore Cab',
        headingDescription: 'Meghana Cab offers Pune to Bangalore Cab services, ensuring a comfortable and efficient travel experience over long distances. Whether it is a business trip, vacation, or family visit, our well-maintained cabs and skilled drivers provide a safe and smooth ride. Choose from a range of vehicle options to match your travel needs, enjoy transparent fares, timely pickups, and round-the-clock support. Book your Pune to Bangalore Cab with Meghana Cab and travel stress-free with trusted service and complete peace of mind.',


        top: 'Top Places to Visit in Bangalore with Meghana Cab',

 "topPlaces": [
  {
    "title": "Lalbagh Botanical Garden",
    "description": "Spread over 240 acres, this iconic garden was initiated by Hyder Ali in the 1760s and later enhanced by Tipu Sultan. It features an exquisite glasshouse modeled on London’s Crystal Palace, age-old trees, intricate fountains, lotus ponds, and a geological monument dating back 3,000 million years. It hosts vibrant flower shows during Republic Day and Independence Day, attracting thousands of admirers." 
  },
  {
    "title": "Cubbon Park",
    "description": "A lush green oasis of 300 acres established in 1870 and now home to rare flora, historical monuments, century-old bandstands, and the State Library. This serene space is perfect for morning walks, birdwatching, and picnics—earning Bangalore its nickname, the ‘Garden City’." 
  },
  {
    "title": "Bangalore Palace",
    "description": "Built in Tudor revival style inspired by Windsor Castle, this 19th-century palace boasts fortified towers, elegant wood paneling, vintage photographs, and ornate interiors. It remains a vivid reminder of the Wodeyar dynasty’s royal legacy and occasionally hosts cultural events and concerts." 
  },
  {
    "title": "Nandi Hills",
    "description": "Once Tipu Sultan’s summer retreat, this hill station stands at 1,478 m and offers breathtaking sunrise views over the Deccan Plateau. It has historical temples, botanical gardens, paragliding, cycling trails, and the legendary Tipu’s Drop cliff." 
  },
  {
    "title": "Tipu Sultan’s Summer Palace",
    "description": "A stunning Indo-Islamic wooden structure built in 1791, renowned for its teak arches, frescoed walls, and tiger motifs. This was Tipu’s leisure abode and still reflects royal life during the Anglo-Mysore era." 
  },
  {
    "title": "Bannerghatta Biological Park",
    "description": "A sprawling wildlife reserve featuring a zoo, safari, and butterfly park. Families and wildlife lovers can spot tigers, bears, herbivores, and enjoy a guided safari ride through forested terrain offering education and excitement." 
  },
  {
    "title": "Vidhana Soudha",
    "description": "India’s largest legislative building, completed in 1956 in neo-Dravidian style. Its illuminated granite façade stands majestic at night, flanked by the historic Attara Kacheri (High Court) and surrounded by elegant colonial-era lawns." 
  },
  {
    "title": "ISKCON Temple Bangalore",
    "description": "This serene modern temple is dedicated to Lord Krishna and blends traditional Vaishnavite architecture with ample prayer halls, vibrant festivals, a vegetarian restaurant, and panoramic views of the city skyline." 
  },
  {
    "title": "Ulsoor Lake & Jawaharlal Nehru Planetarium",
    "description": "Ulsoor Lake is one of Bangalore’s oldest water bodies, offering boating, lakeside walks, and island viewpoints. Nearby, the planetarium hosts immersive astronomy shows, workshops, and is a hub for science lovers." 
  },
  {
    "title": "Dodda Basavana Gudi (Bull Temple)",
    "description": "Home to one of the world’s largest monolithic Nandi idols, this 16th-century temple built by Kempe Gowda offers vibrant religious festivals, unique Vijayanagara-style architecture, and an immersive spiritual experience." 
  }
],

 "services": [
    {
        "name": "Pune to Bangalore Outstation Cab",
        "description": "Meghana Cab offers reliable outstation cab services from Pune to Bangalore. Whether it's a personal trip or a business visit, enjoy a smooth, long-distance ride in clean, comfortable vehicles with experienced chauffeurs ensuring safety and punctuality throughout the journey."
    },
    {
        "name": "Taxi Hire for Pune to Bangalore Trip",
        "description": "Hire a taxi for your Pune to Bangalore journey with Meghana Cab and experience hassle-free interstate travel. Our fleet includes sedans, hatchbacks, and SUVs—each equipped for comfort and backed by 24/7 customer support and real-time tracking."
    },
    {
        "name": "Pune to Bangalore One Way Taxi",
        "description": "Looking for a one-way drop from Pune to Bangalore? Meghana Cab offers convenient and affordable one-way taxi services, including flexible departure times and doorstep pickup. Save more while traveling in style with our AC fleet and skilled drivers."
    },
    {
        "name": "Round Trip Cab Pune to Bangalore",
        "description": "Planning a return journey from Pune to Bangalore? Meghana Cab’s round-trip service provides cost-effective rates, clean and well-maintained vehicles, and friendly drivers who stay with you for the entire trip, offering unmatched convenience."
    },
    {
        "name": "Long-Distance Taxi Pune to Bangalore",
        "description": "Travel across states with ease in Meghana Cab’s long-distance taxi from Pune to Bangalore. Designed for comfort over extended durations, our cars offer plush seating, efficient air-conditioning, and dependable drivers trained for highway travel."
    },
    {
        "name": "Book SUV for Pune to Bangalore",
        "description": "Need extra space or traveling with family or colleagues? Book an SUV from Pune to Bangalore with Meghana Cab for a spacious, comfortable, and smooth ride—ideal for long road journeys with luggage or large groups."
    },
    {
        "name": "AC Cab Pune to Bangalore Road Travel",
        "description": "Beat the heat with Meghana Cab’s fully air-conditioned taxi service from Pune to Bangalore. Our AC cabs offer a relaxing ride across scenic routes, with trained drivers who prioritize your comfort, safety, and on-time arrival."
    },
    {
        "name": "Cab for Pune to Bangalore Business Trip",
        "description": "Meghana Cab caters to corporate travelers with premium cab services from Pune to Bangalore. Whether it’s for meetings, events, or airport pickups, we provide prompt service, executive-class vehicles, and billing support for professional needs."
    },
    {
        "name": "Pune to Bangalore Travel with Driver",
        "description": "Sit back and relax while our experienced drivers handle the Pune to Bangalore route. Meghana Cab offers travel services with licensed drivers familiar with the journey, ensuring you reach safely and comfortably without the stress of self-driving."
    },
    {
        "name": "Premium Cab Pune to Bangalore",
        "description": "Upgrade your road travel experience with Meghana Cab’s premium cab services from Pune to Bangalore. Our premium options include top-end sedans and SUVs, well-groomed drivers, and personalized service tailored to your comfort."
    },
    {
        "name": "Pune to Bangalore Sedan Taxi",
        "description": "Book a comfortable sedan taxi for your Pune to Bangalore ride with Meghana Cab. Perfect for solo travelers or couples, our sedans come with ample boot space, reclining seats, and smooth suspension for a restful long-distance journey."
    },
    {
        "name": "Car Hire Pune to Bangalore",
        "description": "Choose Meghana Cab for flexible car hire options from Pune to Bangalore. Whether you need a car for a one-way drop, full-day rental, or outstation stay, we offer the right car with fair pricing and reliable driver support."
    },
    {
        "name": "Online Cab Booking Pune to Bangalore",
        "description": "Book your Pune to Bangalore cab online in just minutes with Meghana Cab. Our intuitive platform ensures fast bookings, multiple car options, real-time fare visibility, and secure payment—all from your mobile or desktop."
    },
    {
        "name": "Cab Fare Pune to Bangalore",
        "description": "Get transparent and affordable fare estimates for Pune to Bangalore cabs with Meghana Cab. Our pricing includes fuel, tolls, and driver charges—so you know exactly what you’re paying, with no hidden costs or last-minute surprises."
    },
    {
        "name": "Pune to Bangalore Car Rental",
        "description": "Rent a car from Pune to Bangalore with Meghana Cab for flexible, private travel. Ideal for leisure or business use, our rentals offer a wide selection of vehicles, 24x7 availability, and expert support throughout your trip."
    }
],

"tableData": [
    ["Pune to Bangalore Outstation Cab", "Taxi Hire for Pune to Bangalore Trip"],
    ["Pune to Bangalore One Way Taxi", "Round Trip Cab Pune to Bangalore"],
    ["Long-Distance Taxi Pune to Bangalore", "Book SUV for Pune to Bangalore"],
    ["AC Cab Pune to Bangalore Road Travel", "Cab for Pune to Bangalore Business Trip"],
    ["Pune to Bangalore Travel with Driver", "Premium Cab Pune to Bangalore"],
    ["Pune to Bangalore Sedan Taxi", "Car Hire Pune to Bangalore"],
    ["Online Cab Booking Pune to Bangalore", "Cab Fare Pune to Bangalore"],
    ["Pune to Bangalore Car Rental", ""],
    ["", ""]
],







"whychoose": [
    {
        "WhyChooseheading": "Comfortable Pune to Bangalore Cab Service",
        "WhyChoosedescription": "Meghana Cab offers a smooth and comfortable cab service from Pune to Bangalore, perfect for business trips, family travel, or long-distance leisure rides. Enjoy a stress-free journey with our spacious and well-maintained cabs."
    },
    {
        "WhyChooseheading": "On-Time Pick-Up and Drop",
        "WhyChoosedescription": "Punctuality is our promise. Our Pune to Bangalore cab service ensures that your pick-up and drop are always on time, helping you stay on schedule for work, events, or travel commitments."
    },
    {
        "WhyChooseheading": "Trained and Reliable Long-Distance Drivers",
        "WhyChoosedescription": "Our experienced drivers are trained for long-distance intercity travel and are familiar with the Pune to Bangalore route. They prioritize your safety, comfort, and travel preferences throughout the journey."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Cab Fare",
        "WhyChoosedescription": "Get the best value for your money with Meghana Cab’s affordable Pune to Bangalore cab rates. Our pricing is clear and transparent, with no hidden charges—just honest fares you can trust."
    },
    {
        "WhyChooseheading": "Safe and Well-Maintained Vehicles",
        "WhyChoosedescription": "All our cabs are equipped with safety features like GPS tracking, seat belts, and regularly serviced engines. We ensure a safe and reliable ride from Pune to Bangalore for every customer."
    },
    {
        "WhyChooseheading": "24/7 Cab Availability for Pune to Bangalore Route",
        "WhyChoosedescription": "Travel on your schedule—day or night. Meghana Cab offers 24/7 availability for the Pune to Bangalore cab route, allowing you to book a ride whenever it's most convenient for you."
    },
    {
        "WhyChooseheading": "Flexible Travel Options and Custom Plans",
        "WhyChoosedescription": "Whether it’s a one-way trip, round trip, or you need halts along the way, we offer flexible travel plans for your Pune to Bangalore cab journey to match your personal travel needs."
    },
    {
        "WhyChooseheading": "Easy Online Booking and Assistance",
        "WhyChoosedescription": "Book your Pune to Bangalore cab in just a few clicks via our website or mobile app. Need help? Our friendly support team is always ready to assist you with bookings and travel queries."
    }
]

















    }

const faqData = [
    {
        question: "How can I book a Pune to Bangalore cab with Meghana Cab?",
        answer: "You can book a cab from Pune to Bangalore quickly through the Meghana Cab website or by calling our customer support at +91 9075462128."
    },
    {
        question: "What types of cabs are available for Pune to Bangalore travel?",
        answer: "Meghana Cab offers hatchbacks, sedans, SUVs, and tempo travellers for the Pune to Bangalore route, depending on your travel needs."
    },
    {
        question: "Is the Pune to Bangalore service available for one-way trips?",
        answer: "Yes, we provide both one-way and round-trip cab services from Pune to Bangalore at competitive rates."
    },
    {
        question: "How long does it take to travel from Pune to Bangalore by cab?",
        answer: "The road journey from Pune to Bangalore typically takes around 13 to 15 hours depending on traffic and the chosen route."
    },
    {
        question: "Are tolls and interstate taxes included in the cab fare?",
        answer: "Toll charges, parking fees, and interstate taxes are extra and transparently communicated during the booking process."
    },
    {
        question: "Is it safe to travel long distance like Pune to Bangalore by cab?",
        answer: "Yes, Meghana Cab ensures safety and comfort. Our drivers are experienced in long-distance travel and vehicles are well-maintained."
    },
    {
        question: "Can I schedule multiple stops during my Pune to Bangalore trip?",
        answer: "Yes, you can plan custom stops on the way. Just let us know in advance so we can arrange it accordingly."
    },
    {
        question: "Are your cab services from Pune to Bangalore available 24/7?",
        answer: "Absolutely. Meghana Cab operates 24/7, so you can book your Pune to Bangalore ride anytime, including night and early morning."
    },
    {
        question: "What payment options do you offer for long-distance cab bookings?",
        answer: "We accept UPI, credit/debit cards, online banking, and cash payments to ensure flexibility and convenience."
    },
    {
        question: "How can I get in touch with Meghana Cab for booking a Pune to Bangalore cab?",
        answer: "For bookings or questions, call Meghana Cab at +91 9075462128. Our support team is always ready to help."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Suresh Iyer',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“I booked Meghana Cab for a Pune to Bangalore journey. The experience was fantastic — smooth ride, excellent driver, and great customer service throughout.”',
    },
    {
        name: 'Ms. Anuja Rao',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“We travelled from Pune to Bangalore with Meghana Cab and everything went perfectly. The car was comfortable, and the driver was courteous and well-informed.”',
    },
];













































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Bangalore Cab",
  "image": "https://www.meghanacabs.com/assets/images/pune-to-bangalore-cab.jpg",
  "description": "Book Pune to Bangalore outstation cabs with Meghana Cabs. One way and round trip taxi services available with AC, SUV, and Sedan options. Reliable and comfortable travel with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5405"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "8999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-bangalore-cab"
  }
};







    return (
        <div>
<Helmet>
  <title>Pune to Bangalore Cab | Outstation & Round Trip Taxi | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Bangalore outstation cabs with Meghana Cabs. One way and round trip taxi services available with AC, SUV, and Sedan options. Reliable and comfortable travel with professional drivers." 
  />
  <meta 
    name="keywords" 
    content="Pune to Bangalore Outstation Cab, Taxi Hire for Pune to Bangalore Trip, Pune to Bangalore One Way Taxi, Round Trip Cab Pune to Bangalore, Long-Distance Taxi Pune to Bangalore, Book SUV for Pune to Bangalore, AC Cab Pune to Bangalore Road Travel, Cab for Pune to Bangalore Business Trip, Pune to Bangalore Travel with Driver, Premium Cab Pune to Bangalore, Pune to Bangalore Sedan Taxi, Car Hire Pune to Bangalore, Online Cab Booking Pune to Bangalore, Cab Fare Pune to Bangalore, Pune to Bangalore Car Rental" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/5.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetobanglorecab;